// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__WiYT0","FooterContent":"Footer_FooterContent__ZSd3u","ContactInfo":"Footer_ContactInfo__eRJhd","CopyrightInfo":"Footer_CopyrightInfo__2o+9z"};